import React, { Component } from "react";
import "./rule.scss";
import privacyRuleIcon from "../assets/privacyRule.png";

export default class privacyRule extends React.Component {
  render() {
    return (
      <div className="ruleHome">
        <h3 className="ruleTitle">隐私权政策</h3>
        <br />
        <div className="rulecontent titleRight">最近更新日期：2025年7月21日</div>
        <br />
        <div className="rulecontent Bigboole">提示条款</div>
        <br />
        <div className="rulecontent">
          您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，邮宝网服务提供者（或简称“我们”）制定本《隐私权政策》（下称“本政策
          /本隐私权政策”）并提醒您：
        </div>
        <br />
        <div className="rulecontent">
          本政策适用于邮宝网提供的所有产品和服务。
        </div>
        <br />
        <div className="rulecontent">
          需要特别说明的是，<span className="fontwet">本政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您另行说明的隐私权政策。</span> 
        </div>
        <br />
        <div className="rulecontent">
        <span className="fontwet"> 在使用邮宝网各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。</span>如对本政策内容有任何疑问、意见或建议，您可通过邮宝网提供的各种<span className="lanse">联系方式</span>与我们联系。
        </div>
        <br />
        <br />
        <br />
        <div className="rulecontent">
          <span className="Bigboole">第一部分 定义</span> 
          <br />
          <br />
          1、<span className="fontwetNo">邮宝网：</span>指邮宝网（域名为 youbao360.com）网站及邮宝客户端。
          <br />
          2、<span className="fontwetNo">邮宝网服务提供者：</span>指邮宝网的互联网信息及软件技术服务提供者北京风暴迅达科技有限公司。
          <br />
          3、<span className="fontwetNo">个人信息：</span>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
          <br />
          4、<span className="fontwetNo">个人敏感信息：</span>指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。
          <br />
          5、<span className="fontwetNo">个人信息删除：</span>指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
          <br />
          6、<span className="fontwetNo">儿童：</span>指不满十四周岁的未成年人。
          <br />
          7、除另有约定外，本政策所用定义与《邮宝平台服务协议》中的定义具有相同的涵义。
        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole"> 第二部分 隐私权政策</span>
          <br />
          <br />
          本隐私权政策部分将帮助您了解以下内容：
          <br />
          1、我们如何收集和使用您的信息。
          <br />
          2、我们如何使用Cookie和同类技术。
          <br />
          3、我们如何共享、转让、公开披露您的信息。
          <br />
          4、我们如何保护您的信息。
          <br />
          5、您如何管理您的信息。
          <br />
          6、我们如何处理未成年人的信息。
          <br />
          7、您的信息如何在全球范围转移。
          <br />
          8、本隐私权政策如何更新。
          <br />
          9、如何联系我们。
          <br />
        </div>
        <br />
        <br />
        <div className="rulecontent">
         <span className="BigbooleTwo">一、 我们如何收集和使用您的信息</span> 
          <br />
          <br />
          在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：
          <br />
         <span className="fontwet">1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；</span>
          <br />
          <span className="fontwet">2、为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。</span>
          <br />
          <span className="fontwet">您理解并同意：</span> <br />
          <span className="fontwet">1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，相应的，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；</span>
          <br />
          <span className="fontwet">2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过邮宝网提供的各种联系方式与我们联系，我们会尽快为您作出解答。</span><br />
		  <span className="fontwet">3、第三⽅服务（SDK）明细如下：<br /></span>
			{/* <img src={privacyRuleIcon} /><br /> */}
			<span className="fontwet">第三⽅ SDK 信息清单</span><br />
			<span className="fontwet">安卓系统有关</span>
      <table border='1' cellSpacing={0}>
        <thead>
          <tr>
            <th>SDK名称</th>
            <th>收集信息</th>
            <th>第三⽅机构名称/所属企业</th>
            <th>功能⽬的</th>
            <th>第三⽅SDK服务商隐私协议⽂档</th>
          </tr>    
        </thead>
        <tbody>
          <tr>
            <td>环信即时通讯SDK</td>
            <td>Android ID（AndroidID、ANDROID ID）、IMSI、MAC地址、⽹络类型(ApnType)、WIFI的SSID</td>
            <td>北京易掌云峰 科技有限公司</td>
            <td>即时通讯，实现聊天、信息推送</td>
            <td><a href="https://www.easemob.com/protocol" style={{textDecoration: 'underline'}}>参考：环信官⽅隐私协议</a></td>
          </tr>
          <tr>
            <td>腾讯openSDK</td>
            <td>IMSI、获取⽹络信息、SSID</td>
            <td>深圳市腾讯计算机系统有限 公司</td>
            <td>实现app分享功能，分享微信朋友圈、QQ、QQ登录</td>
            <td><a href="https://privacy.qq.com/policy/sdk-privacypolicy" style={{textDecoration: 'underline'}}>参考：腾讯隐私保 护平台</a></td>
          </tr>
          <tr>
            <td>【友盟+消息推送】SDK</td>
            <td>设备ID、IMEI、MAC、Android ID（AndroidID、ANDROID ID）、OpenUDID、GUID、SIM卡IMSI、地理位置、已安装APP信息</td>
            <td>友盟同欣（北 京）科技有限 公司</td>
            <td>实现⻚⾯⽤户数据统计分析、社会化分享、消息推送和第三方登录</td>
            <td><a href="https://www.umeng.com/page/policy" style={{textDecoration: 'underline'}}>参考：友盟官⽹隐私协议</a></td>
          </tr>
          <tr>
            <td>Bugly SDK</td>
            <td>IMEI、Android ID（AndroidID、ANDROID ID）、SIM卡序列号、IMSI、⽇志信息、设备 ID(idfv)、联⽹信息、系统名称、系统版本以及国家码、MAC地址</td>
            <td>腾讯科技(深圳)有限公司</td>
            <td>收集相关信息进⾏统计分析，以提升APP性能</td>
            <td><a href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf" style={{textDecoration: 'underline'}}>参考：Bugly SDK 隐私保护声明</a></td>
          </tr>
          <tr>
            <td>讯⻜SDK</td>
            <td>Android ID（AndroidID、ANDROID ID）、IP地址、GPS、WIFI、IMSI、MAC地址</td>
            <td>科⼤讯⻜股份有限公司</td>
            <td>语⾳识别、语⾳合成</td>
            <td><a href="https://www.xfyun.cn/doc/policy/privacy.html" style={{textDecoration: 'underline'}}>参考：讯⻜隐私协议</a></td>
          </tr>
          <tr>
            <td>【APP支付客户端】SDK</td>
            <td>MAC地址、唯一设备标识码、位置信息、电话号码Wi-Fi地址、设备ID、IMSI</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>APP第三方支付服务、第三方登录</td>
            <td><a href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132" style={{textDecoration: 'underline'}}>参考:支付宝SDK隐私协议</a></td>
          </tr>
          <tr>
            <td>七牛云SDK</td>
            <td>包括设备名称、设备型号、设备设置、识标符、地区和语言设置</td>
            <td>上海七牛信息技术有限公司</td>
            <td>储存用户上传的图片和视频</td>
            <td><a href="https://www.qiniu.com/agreements/privacy-right" style={{textDecoration: 'underline',color:'#0000EE'}}>参考：七牛云隐私协议</a></td>
          </tr>
        </tbody>
      </table>
      <br />
      <span className="fontwet">IOS系统有关</span>
      <table border='1' cellSpacing={0}>
        <thead>
          <tr>
            <th>SDK名称</th>
            <th>收集信息</th>
            <th>第三⽅机构名称/所属企业</th>
            <th>功能⽬的</th>
            <th>第三⽅SDK服务商隐私协议⽂档</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>环信即时通讯SDK</td>
            <td>iOS⼴告标识符（IDFA）</td>
            <td>北京易掌云峰 科技有限公司</td>
            <td>即时通讯，实现聊天、信息推送</td>
            <td><a href="https://www.easemob.com/protocol" style={{textDecoration: 'underline'}}>参考：环信官⽅隐私协议</a></td>
          </tr>
          <tr>
            <td>Umeng统计分析SDK</td>
            <td>iOS⼴告标识符（IDFA）、地理位置</td>
            <td>友盟同欣（北 京）科技有限 公司</td>
            <td>实现⻚⾯⽤户数据统计分析</td>
            <td><a href="https://www.umeng.com/page/policy" style={{textDecoration: 'underline'}}>参考：友盟官⽹隐私协议</a></td>
          </tr>
          <tr>
            <td>讯⻜SDK</td>
            <td>UUID、IP地址、GPS、WIFI</td>
            <td>科⼤讯⻜股份有限公司</td>
            <td>语⾳识别、语⾳合成</td>
            <td><a href="https://www.xfyun.cn/doc/policy/privacy.html" style={{textDecoration: 'underline'}}>参考：讯⻜隐私协议</a></td>
          </tr>
        </tbody>
      </table>
			{/* <span className="fontwet">应用在使用的过程中会征得用户同意后将IMEI等个人信息向第三方“stats.umsns.com”进行传输，主要的目的在于用户通过友盟分享商品。</span> */}
          <br /> <br />
          我们会为实现本政策下述的各项功能，收集和使用您的个人信息： <br />
          <span className="BigbooleTwo">（一） 帮助您成为我们的会员</span>  
          <br /><br />
          <span className="BigbooleTwo">1、基础会员服务</span>
          <br />
          <br />
          我们通过邮宝平台账户为您提供基础会员服务。为注册成为会员并使用我们的会员服务，您需要提供<span className="fontwetNo">手机号码、拟使用的会员名和密码</span>用于创建邮宝平台账户。如果您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。
          <br />
          <span className="fontwet">对于需要通过邮宝平台账户才能使用的服务，我们可能会根据您提供的上述信息校验您的会员身份，确保我们是在为您本人提供服务。</span> 
          <br />
          我们会根据您的会员账户使用情况及平台设置的会员等级计算规则确定您当前的会员等级，并为您提供相应会员等级所对应的基本权益。
          <br />
          <br />
          <span className="BigbooleTwo"> 2、附加会员服务</span>
          <br />
          实人认证：您可以根据认证要求提供相应的<span className="fontwetNo">身份信息（身份证及其他身份证件信息）、生物识别特征（静态或动态的面部特征）</span>以完成实人认证。
          <br />
          授权登录：我们可能会根据您的授权从第三方处获取您的第三方账户信息，并与您的邮宝平台账户进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。
          <br />
          <span className="fontwet">其他会员角色服务：如果您申请注册成为卖家、服务商或其他存在额外身份认证要求的会员角色，您需主动向我们提供身份信息及/或企业相关信息，用于您身份及特殊会员角色获取资格的核验、登记、公示及其他我们明确告知的目的。</span> 
          <br />
          <span className="fontwet">3、账户信息展示：如果您已拥有邮宝平台账户，我们可能会在邮宝平台服务中显示您的上述个人信息</span> （实人认证仅显示认证是否通过的结果）， <span className="fontwet">以及您在邮宝平台上或与邮宝平台账户相关联的产品和服务中执行的操作，包括通过邮宝平台账户集中展示您的个人资料、优惠权益、交易订单。我们会尊重您对邮宝平台服务和邮宝平台账户设置所做的选择。</span>
          <br />
          <br />
          {/* <span className="BigbooleTwo">（二） 为您提供商品或服务信息展示</span>  
          <br />
          在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动（在静默状态下或在后台运行时）收集您的使用情况并存储为网络日志信息，包括：
          <br />
          设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、MAC地址、设备环境、移动应用列表等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）。
          <br />
          服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、添加至购物车、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。
          <br />
         <span className="fontwet">请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。</span> 如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
          <br /> */}
          {/* <span className="fontwet">为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和您使用邮宝的网站或客户端时的浏览使用信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息和可能的商业广告。</span>
          <br /> */}
          {/* 此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。
          <br /> */}
          <span className="BigbooleTwo">（二） 为您提供收藏、加购、关注与分享功能</span>
          <br />
          <br />
          在您浏览我们网站或客户端的过程中，您可以选择商品及/或服务进行收藏、与商家/品牌/其他会员建立关注关系、通过我们提供的功能组件向其他第三方分享信息。在您使用上述功能的过程中，我们会收集包括您的收藏的记录、关注关系、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。
          <br />
          <span className="BigbooleTwo">（三）帮助您完成下单及订单管理</span>
          <br />
          当您在我们的产品及/或服务中订购具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,您需至少提供您的<span className="fontwetNo">收货人姓名、收货地址、收货人联系电话，</span>同时该订单中会载明您所购买的商品及/或服务信息、具体订单号、订单创建时间、您应支付的金额，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。
          <br />
          您可以通过邮宝网为其他人订购商品及/或服务，您需要提供该实际订购人的前述个人信息，<span className="fontwetNo">若其中涉及儿童个人信息的，您需在提供前征得对应儿童监护人的同意。</span>
          <br />
          为便于您了解查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
          <br />
          您可额外填写/选择包括<span className="fontwetNo"></span>其他联系电话、收货时间在内的更多附加信息以确保商品或服务的准确送达。
          <br />
          <span className="BigbooleTwo"> （四） 帮助您完成支付</span>
          <br />
          <span className="fontwetNo">为完成订单支付，您需要提供微信、支付宝账户并选择付款方式，</span><span className="fontwet">我们会将您的邮宝平台账户会员名、对应的微信、支付宝账户会员名、订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在应用程序中嵌入的微信、支付宝软件工具开发包（软件工具开发包在本政策中简称“SDK”）等方式与第三方支付公司共享。如您选择由其他金融机构为您提供支付服务的，我们还会将您的包括银行卡号、有效期在内的银行卡支付必要信息与您选择的相应金融机构共享。</span>
          <br />
          为使我们及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务，您同意我们可自您所选择的交易对象、微信、支付宝或您选择的其他金融机构处收集与支付进度相关信息。
          <br />
          <span className="BigbooleTwo"> （五） 帮助向您完成商品或服务的交付</span>
          <br />
          为保证您购买的商品及/或服务能够顺利、安全、准确送达，我们会向为邮宝平台提供物流信息系统和技术服务的浙江菜鸟供应链管理有限公司披露<span className="fontwetNo">订单相关配送信息，</span>并由其根据商品及/或服务提供主体的指定向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。
          <br />
          为使我们及时获悉并确认交付进度及状态，向您提供售后与争议解决服务，您同意我们可自物流相关服务主体处收集与交付进度相关信息。
          <br />
          <span className="BigbooleTwo"> （六） 客服及争议处理</span>
          <br />
          当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的账户及系统安全，<span className="fontwet">我们需要您提供必要的个人信息以核验您的会员身份。</span>
          <br />
          <span className="fontwet">为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账号信息和订单信息。</span>
          <br />
          为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。
          <br />
          <span className="BigbooleTwo"> （七） 为您提供评论、问答等信息公开发布功能</span>
          <br />
          您可通过我们为您提供的评论、问答、论坛、晒单分享、直播及其他信息发布功能公开发布信息，包括作为会员可发布图文/视频/直播内容、发表评价及问答内容、以及作为卖家发布商品及/或服务相关信息、店铺相关信息。
          <br />
          我们可能会根据您的会员类型及网络日志信息判断您是否可享受对应功能权限（例如只有曾购买过某商品的会员才可通过问大家对其他会员针对该商品的提问做出回答）。
          <br />
          <span className="fontwet">请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及儿童个人信息的，您需在发布前征得对应儿童监护人的同意。</span>
          <br />
          <span className="BigbooleTwo"> （八） 为您提供安全保障</span>
          <br />
          为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或邮宝网相关协议规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全SDK收集您的设备信息、服务日志信息，并可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
          <br />
          <span className="BigbooleTwo"> （九） 为您提供其他附加服务</span>
          <br />
          为向您提供更便捷、更优质的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。<span className="fontwet">如果您不提供这些信息，不会影响您使用邮宝网的浏览、搜索、购买等基本服务，</span>但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：
          <br />
          1、基于位置信息的服务：我们会在您开启位置权限后(或在后台状态下)访问获取您的位置信息，根据您的位置信息为您提供您需求的页面展示、产品及/或服务，比如向您附近的优惠信息。
          <br />
          2、基于相机/摄像头的附加服务：您可在开启相机/摄像头权限后使用该功能进行拍摄照片或视频用于评价、分享，以及特定场景下经您授权的人脸识别等功能。当您使用该附加功能进行人脸识别时我们会收集您的面部特征，且严格在经您授权同意的范围内使用，未来如我们拟使用您的<span className="fontwetNo">面部信息</span>为您提供其他产品及/或服务功能的，我们会再次与您确认。<span className="fontwet">请您知晓，即使您已同意开启相机权限，我们也仅会在您主动点击客户端内相机图标或录制视频时通过相机获取照片信息。</span>
          <br />
          3、基于相册（图片库/视频库）的图片/视频访问及上传的附加服务：您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、发表评论/分享、拍照购物或与客服沟通提供证明等功能。<span className="fontwet">我们可能会通过您所上传的照片/图片来识别您需要购买的商品或服务，或使用包含您所上传照片或图片的评论信息。为实现您的好友、活动优惠等链接分享需求，我们可能会在设备本地读取您最近一次主动保存的图片链接地址。</span>
          <br />
          4、基于麦克风的语音技术相关附加服务：您可在开启麦克风权限后使用麦克风实现语音购物功能，或与客服联系或与客服机器人实现语音交互，在这些功能中我们会收集您的<span className="fontwetNo">录音内容</span>以识别您的购物需求，或响应您的客服及争议处理等需求。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。
          <br />
          5、基于通讯录信息的附加服务：我们将在您开启通讯录权限后收集您的通讯录信息使您在购物时可以更便利地取用您通讯录内的联系人信息，无需再手动输入，包括您可以直接为通讯录中的联系人手机号进行充值；此外，为提升您在使用我们产品及/或服务过程中的社交互动分享乐趣，与您认识的人分享购物体验，在经您同意的前提下，我们也可能对您联系人的姓名和电话号码进行加密收集，帮助您判断您的通讯录联系人是否同为我们的会员进而在邮宝网为你们的交流建立联系，同时，会员可选择开启或关闭好友隐私权限决定自己是否可被其他会员通过手机号码搜索、联系。
          <br />
          6、基于即时通讯功能的附加服务：我们为了确保为您提供实时信息服务，例如实时接收好友发送给您的新消息。我们会在您的设备状态发生变化时（网络状态、开机后、应用更新、退出等），尝试自启动消息服务框架来接受消息推送。此外，我们还接入了第三方消息推送服务，更好地保证为您提供的服务的质量。
          <br />
          7、基于电话状态的附加服务：为保障您的账号与使用安全，您需要授权我们读取本机识别码。
          <br />
          您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息
          （地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录、日历及/或电话状态的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或我们客户端“我的邮宝-设置-隐私—系统权限”中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
          <br />
          <span className="BigbooleTwo"> （十）其他 </span>
          <br />
          <span className="fontwet">1、若你提供的信息中含有其他用户的个人信息，在向邮宝网提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第九条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。</span>
          <br />
          <span className="fontwet">2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</span>
          若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
          <br />
          3、征得授权同意的例外
          <br />
          您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：
          <br />
          （1）与国家安全、国防安全有关的；
          <br />
          （2）与公共安全、公共卫生、重大公共利益有关的；
          <br />
          （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
          <br />
          （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          <br />
          （5）您自行向社会公众公开的个人信息；
          <br />
          （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
          <br />
          （7）根据与您签订和履行相关协议或其他书面文件所必需的；
          <br />
          （8）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；
          <br />
          （9）为合法的新闻报道所必需的；
          <br />
          （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          <br />
          （11）法律法规规定的其他情形。
          <br />
          请知悉，根据适用的法律，若我们<span className="fontwet">对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，</span>或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善邮宝网的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），<span className="fontwet">则此类处理后数据的使用无需另行向您通知并征得您的同意。</span>
          <br />
          4、如我们停止运营邮宝网产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。
        </div>
        <br />
        <div className="rulecontent">
        <span className="Bigboole">二、我们如何使用Cookie和同类技术</span>
          <br />
          <br />
          <span className="BigbooleTwo">（一）Cookie</span>
          <br />
          为确保网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储Cookie、Flash
          Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。借助于
          Cookie，网站能够存储您的偏好或购物车内的商品等数据。
          <br />
          <span className="fontwet">如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。</span>有关详情，请参见
          AboutCookies.org。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。
          <br />
          <span className="BigbooleTwo">（二）Cookie同类技术</span>
          <br />除
          Cookie外，我们还会在网站上使用网站信标、像素标签、ETag等其他同类技术。
          <br />
          例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
          <br />
          ETag（实体标签）是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie。ETag可以帮助我们避免不必要的服务器负载，提高服务效率，节省资源、能源，同时，我们可能通过ETag来记录您的身份，以便我们可以更深入地了解和改善我们的产品或服务。<span className="fontwet">大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。</span>但请注意，如果停用ETag，您可能无法享受相对更佳的产品或服务体验。
        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole"> 三、 我们如何共享、转让、公开披露您的信息</span>
          <br />
          <br />
          <span className="BigbooleTwo">（一）共享</span>
          <br />
          我们不会与邮宝网服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
          <br />
          1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
          <br />
          2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
          <br />
          3、在您主动选择情况下共享：您通过邮宝平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。
          <br />
          4、与授权合作伙伴共享：<span className="fontwet">我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，</span>我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。对于涉及儿童个人信息的，我们不允许合作伙伴进行转委托。
          <br />
          目前，我们的授权合作伙伴包括以下类型：
          <br />
          <br />
          （1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。
          <br />
          （2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
          <br />
          为了使您能够使用上述服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。如您使用华为/小米/魅族手机时，华为/小米/魅族Push
          SDK需要读取您的设备识别号、联网相关信息，用于推送/下发通知栏消息；如您使用向微博分享信息功能，相关SDK会收集您的设备识别号、联网相关信息；如您使用高德提供的地图服务，高德SDK需要您打开设备位置权限并收集设备所在位置、设备识别号、联网相关信息。
          <br />
          我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
          <br />
          <span className="BigbooleTwo">（二）转让</span>
          <br />
          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
          <br />
          1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
          <br />
          2、在邮宝网服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
          <br />
          <span className="BigbooleTwo">（三）公开披露</span>
          <br />
          我们仅会在以下情况下，公开披露您的个人信息：
          <br />
          1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
          <br />
          <span className="fontwet">2、如果我们确定您出现违反法律法规或严重违反邮宝平台相关协议及规则的情况，或为保护邮宝平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，</span>包括相关违规行为以及邮宝平台已对您采取的措施。例如，若您因出售假冒商品而严重违反邮宝规则，我们可能会公开披露您的店铺认证主体信息与违规情况。
          <br />
          <span className="BigbooleTwo">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span>
          <br />
          以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
          <br />
          1、与国家安全、国防安全有关的；
          <br />
          2、与公共安全、公共卫生、重大公共利益有关的；
          <br />
          3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
          <br />
          4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          <br />
          5、您自行向社会公众公开的个人信息；
          <br />
          6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
          <br />
          请知悉，根据适用的法律，若我们<span className="fontwet">对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</span>
        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole"> 四、我们如何保护您的信息</span>
          <br />
          <br />
          （一）我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受
          SSL协议加密保护；我们同时对邮宝网网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
          <br />
          我们指定了专人负责儿童个人信息的保护，严格设定信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。
          <br />
          （二）我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过网络安全等级保护的三级以上测评和ISO27001认证。
          <br />
          （三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。<span className="fontwet">我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求，</span>例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：
          <br />
          1、完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；
          <br />
          2、保证我们为您提供服务的安全和质量；
          <br />
          3、您是否同意更长的留存期间；
          <br />
          4、是否存在保留期限的其他特别约定。
          <br />
          <span className="fontwet">在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span>
          <br />
          （四）互联网并非绝对安全的环境，使用邮宝平台服务时，<span className="fontwet">我们强烈建议您不要使用非邮宝平台的通信方式发送您的信息。</span>您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。
          <br />
          在使用邮宝网服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如<span className="fontwetNo">联络方式</span>或<span className="fontwetNo">联系地址</span>。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络邮宝网客服，以便我们根据您的申请采取相应措施。
          <br />
          请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
          <br />
          请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
          <br />
          （五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过邮宝网公告方式获得。
          <br />
          （六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
          <br />{" "}
          我们已制定儿童个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以APP推送通知、发送邮件/短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将依法承担相应的法律责任。
          <br />
          同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole"> 五、您如何管理您的信息</span>
          <br />
          <br />
          您可以通过以下方式访问及管理您的信息：
          <br />
          <span className="BigbooleTwo">（一）查询、更正和补充您的信息</span>
          <br />
          您有权查询、更正或补充您的信息。您可以通过以下方式自行进行：
          <br />
          1、登录邮宝网，进入“我的”首页，点击个人账户设置后查询、更正个人资料及个人账户相关信息；
          <br />
          2、登录手机邮宝客户端，进入“我的邮宝-个人信息”对个人资料、账户与安全及我的收货地址等信息进行查询、更正或补充；
          <br />
          3、登录邮宝网并选择联系客服，或登录手机邮宝客户端并选择“我的邮宝—设置”寻求帮助，协助您查询、更正或补充您的信息。
          <br />
          <span className="BigbooleTwo">（二）删除您的信息</span>
          <br />
          您可以通过“（一）查询、更正和补充您的信息”中列明的方式删除您的部分信息。
          <br />
          在以下情形中，您可以向我们提出删除个人信息的请求：
          <br />
          1、如果我们处理个人信息的行为违反法律法规；
          <br />
          2、如果我们收集、使用您的个人信息，却未征得您的明确同意；
          <br />
          3、如果我们处理个人信息的行为严重违反了与您的约定；
          <br />
          4、如果您不再使用我们的产品或服务，或您主动注销了账号；
          <br />
          5、如果我们永久不再为您提供产品或服务。
          <br />
          若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。
          <br />
          <span className="fontwet">当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</span>
          <br />
          <span className="BigbooleTwo">（三）改变您授权同意的范围</span>
          <br />
          每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“第一部分”）。除此之外，您可以在“我的邮宝-账号管理”中设置或与邮宝网客服联系或改变您的智能移动设备的设置等方式给予或收回您的授权同意。
          <br />
          当您收回同意后，我们将不再处理相应的个人信息。<span className="fontwet">但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
          <br />
          <span className="BigbooleTwo">（四）注销您的账户</span>
          <br />
          您可以通过以下方式申请注销您的账户：
          <br />
          1、登录手机邮宝客户端，通过“我的-设置-注销账户”提交账户注销申请；
          <br />
          2、登录邮宝网并选择联系客服，寻求帮助，协助您申请注销您的账户。
          <br />
          在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。
          <br />
          <span className="BigbooleTwo">（五）约束信息系统自动决策</span>
          <br />
          在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害邮宝网商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
          <br />
          <span className="BigbooleTwo">（六）响应您的上述请求?</span>
          <br />
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
          <br />
          我们将在15天内做出答复。如您不满意，还可以通过邮宝网客服发起投诉。
          <br />
          对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
          <br />
          在以下情形中，按照法律法规要求，我们将无法响应您的请求：
          <br />
          1、与国家安全、国防安全有关的；
          <br />
          2、与公共安全、公共卫生、重大公共利益有关的；
          <br />
          3、与犯罪侦查、起诉、审判和执行判决等有关的；
          <br />
          4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；
          <br />
          5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          <br />
          6、涉及商业秘密的。
        </div>
        <br />
        <br />

        <div className="rulecontent">
        <span className="Bigboole"> 六、我们如何处理未成年人的信息</span>
          <br />
          <br />
          <span className="fontwet">在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私权政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</span>
          <br />
          <span className="fontwet">如果我们识别出您是儿童用户的，我们将通知您的监护人并要求您的监护人同意儿童个人信息收集使用规则。对于经父母或其他监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。</span>
          <br />
          <span className="fontwet">若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务的。</span>如您对您所监护的儿童的个人信息有疑问，请通过第九节中的联系方式与我们联系。
        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole">七、您的信息如何在全球范围转移</span>
          <br />
          <br />
          我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
          <br />
          1、适用的法律有明确规定；
          <br />
          2、获得您的明确授权；
          <br />
          3、您通过互联网进行跨境交易等个人主动行为。
          <br />
          针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。
        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole">八、本隐私权政策如何更新</span>
          <br />
          <br />
          我们的隐私权政策可能变更。

          <br />未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在<span style={{color:'#3b8fd9'}}>专门页面</span>上发布对隐私权政策所做的任何变更。

          <br />对于重大变更，我们还会提供更为显著的通知（包括我们会通过邮宝网公示的方式进行通知甚至向您提供弹窗提示）。

          <br />本政策所指的重大变更包括但不限于：

          <br />1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；

          <br />2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；

          <br />3、个人信息共享、转让或公开披露的主要对象发生变化；

          <br />4、您参与个人信息处理方面的权利及其行使方式发生重大变化；

          <br />5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；

          <br />6、个人信息安全影响评估报告表明存在高风险。

          <br />我们还会将本隐私权政策的旧版本在<span className="fontwetNo">邮宝网专门页面</span>存档，供您查阅。

        </div>
        <br />
        <br />
        <div className="rulecontent">
        <span className="Bigboole">九、如何联系我们</span>
          <br />
          <br />
          您可以通过以下方式与我们联系，我们将在15天内回复您的请求：


          <br /> 1、如对本政策内容、儿童个人信息有任何疑问、意见或建议，您可通过邮宝网客服及<span className="fontwetNo">邮宝网服务中心</span>在线客服与我们联系；

          <br />如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，<span className="fontwet">您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</span>

        </div>
        <br />
        <br />
       
        <br />
        <br />
        {/* <div className="rulecontent">四.最终解释权归邮宝所有。</div> */}
      </div>
    );
  }
}
